var map = {
	"./pr-1.png": "e197f",
	"./pr-2.png": "0ca6",
	"./pr-3.png": "9327",
	"./pr-4.png": "4dcd",
	"./pr-5.png": "66aa",
	"./pr-6.png": "29b6",
	"./pr-7.png": "bb54",
	"./pr-8.png": "9201",
	"./pr-9.png": "d45a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8bb4";